import {InjectionToken} from "@angular/core";

export const CONFIG = new InjectionToken('config');



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/constants.ts